import React from 'react'
import styles from './styles.css'
import { Link } from 'react-router-dom'
import capitalize from 'lodash/capitalize'
import HateIcon from './hate.svg'
import LikeIcon from './like.svg'
import LoveIcon from './love.svg'
import SkipIcon from './skip.svg'
import {
  SystemCuratedConsumerSellableReactionRating,
  SystemCuratedItemSurveyStatsFragment
} from '#src/generated/graphql'
import { Experiment, Variation } from '@deal/experiment-js'

interface Props {
  stats: SystemCuratedItemSurveyStatsFragment
}

const getIcon = (rating: SystemCuratedConsumerSellableReactionRating) => {
  switch (rating) {
    case SystemCuratedConsumerSellableReactionRating.DISLIKE:
      return <HateIcon className={styles.icon} />
    case SystemCuratedConsumerSellableReactionRating.LIKE:
      return <LikeIcon className={styles.icon} />
    case SystemCuratedConsumerSellableReactionRating.LOVE:
      return <LoveIcon className={styles.icon} />
    case SystemCuratedConsumerSellableReactionRating.SKIP:
      return <SkipIcon className={styles.icon} />
  }
}

const TerminationState: React.SFC<Props> = ({ stats }) => {
  return (
    <div>
      <div className={styles.content}>
        <div className={styles.title}>That's all!</div>
        <div className={styles.text}>
          We sent your feedback to your expert – this will help them find exactly what you’re
          looking for! Here’s a summary of your responses:
        </div>
        <div className={styles.stats}>
          {stats.ratingStats.map(stat => (
            <div className={styles.stat} key={stat.rating}>
              {getIcon(stat.rating)}{' '}
              <div className={styles.rating}>
                <div className={styles.count}>{stat.count}</div> {capitalize(stat.rating)}
              </div>
            </div>
          ))}
        </div>
      </div>
      <Link to="/favorites" className={styles.cta}>
        See your favorites
      </Link>
    </div>
  )
}

/**
 * HACK: We want to test only showing Like and Dislike options, but we are tracking the liked items as "Loved" so they are still added as favorited items.
 * To do this, we remove "LIKED" from the stats obj and convert the "LOVED" display name to "LIKE"
 */
export default ({ stats }: Props) => (
  <Experiment id="product-survey-remove-like" default="off">
    <Variation id="off">
      <TerminationState stats={stats} />
    </Variation>
    <Variation id="on">
      <TerminationState
        stats={{
          ...stats,
          ratingStats: stats.ratingStats.reduce(
            (stats, stat) => {
              if (stat.rating === SystemCuratedConsumerSellableReactionRating.LIKE) {
                return stats
              } else if (stat.rating === SystemCuratedConsumerSellableReactionRating.LOVE) {
                stats.push({ ...stat, rating: 'LIKE' })
              } else {
                stats.push(stat)
              }
              return stats
            },
            [] as any
          )
        }}
      />
    </Variation>
  </Experiment>
)
